import SvgMask from '../../_Helpers/SvgMask';

interface StudentProgressCellTypes {
	className?: string;
	stageName?: string;
	hideLeftLine?: boolean;
	hideRightLine?: boolean;
	width?: number;
}

const StudentProgressCell: React.FC<StudentProgressCellTypes> = ({
	className,
	stageName,
	hideLeftLine = false,
	hideRightLine = false,
	width
}) => {
	return (
		<div
			className={`student-progress-cell ${className} stage-${stageName} `}
			style={width ? { width: `${width}px` } : undefined}
		>
			{!hideLeftLine && <div className="line line-left"></div>}

			<div className="cell-name">{stageName}</div>

			{!hideRightLine && <div className="line line-right"></div>}
		</div>
	);
};

export default StudentProgressCell;
